<template>
  <teleport to="body">
    <div v-if="open" class="dialog-backdrop" @mousedown.self="$emit('cancel')">
      <form ref="dialog" class="reason-dialog" role="dialog" aria-modal="true" aria-labelledby="downtime-dialog-title" @keydown="onKeydown" @submit.prevent="$emit('confirm', reason)">
        <h2 id="downtime-dialog-title">{{ title }}</h2>
        <label for="downtime-reason">Причина <span>(необязательно)</span></label>
        <textarea id="downtime-reason" ref="textarea" v-model="reason" rows="4" maxlength="1000" placeholder="Укажите причину действия" />
        <div class="actions">
          <button type="button" class="cancel" :disabled="busy" @click="$emit('cancel')">Отмена</button>
          <button type="submit" class="confirm" :disabled="busy">{{ busy ? 'Сохраняем…' : confirmLabel }}</button>
        </div>
      </form>
    </div>
  </teleport>
</template>

<script>
import { nextTick, onBeforeUnmount, ref, watch } from 'vue';

export default {
  name: 'DowntimeReasonDialog',
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, required: true },
    confirmLabel: { type: String, default: 'Подтвердить' },
    busy: { type: Boolean, default: false },
  },
  emits: ['confirm', 'cancel'],
  setup(props, { emit }) {
    const reason = ref('');
    const textarea = ref(null);
    const dialog = ref(null);
    let previouslyFocused = null;
    const restoreFocus = () => {
      previouslyFocused?.focus?.();
      previouslyFocused = null;
    };
    const onKeydown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        emit('cancel');
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...(dialog.value?.querySelectorAll('textarea, button:not(:disabled)') || [])];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    watch(() => props.open, (open) => {
      if (open) {
        previouslyFocused = typeof document === 'undefined' ? null : document.activeElement;
        reason.value = '';
        nextTick(() => textarea.value?.focus());
      } else {
        nextTick(restoreFocus);
      }
    });
    onBeforeUnmount(restoreFocus);
    return { reason, textarea, dialog, onKeydown };
  },
};
</script>

<style scoped>
.dialog-backdrop { position: fixed; z-index: 2000; inset: 0; display: flex; align-items: center; justify-content: center; padding: 16px; background: rgba(16, 24, 40, .45); }
.reason-dialog { box-sizing: border-box; display: flex; flex-direction: column; width: min(460px, 100%); padding: 20px; border-radius: 8px; background: #fff; box-shadow: 0 20px 40px rgba(16, 24, 40, .2); }
h2 { margin: 0 0 16px; color: #1d2939; font-size: 18px; }
label { display: block; margin-bottom: 6px; color: #344054; font-size: 13px; font-weight: 600; }
label span { color: #98a2b3; font-weight: 400; }
textarea { box-sizing: border-box; width: 100%; padding: 9px 10px; resize: vertical; border: 1px solid #d0d5dd; border-radius: 6px; font: inherit; }
.actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px; }
button { height: 32px; padding: 0 14px; border-radius: 5px; font-size: 13px; cursor: pointer; }
.cancel { border: 1px solid #d0d5dd; background: #fff; color: #344054; }
.confirm { border: 1px solid #007bff; background: #007bff; color: #fff; }
button:disabled { cursor: not-allowed; opacity: .55; }
</style>
